import { render, staticRenderFns } from "./lookForHouse.vue?vue&type=template&id=2a33c2e4&scoped=true&"
import script from "./lookForHouse.vue?vue&type=script&lang=js&"
export * from "./lookForHouse.vue?vue&type=script&lang=js&"
import style0 from "./lookForHouse.vue?vue&type=style&index=0&id=2a33c2e4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a33c2e4",
  null
  
)

export default component.exports